import { httpClientAuthorized, httpClientUnAuthorized } from '../httpClient';
import { METHODS, ENDPOINTS } from 'shared/constants';
import { AppUser } from 'shared/types';

export const fetchMarket = async () => {
  const response = await httpClientAuthorized<any>({
    method: METHODS.GET,
    url: ENDPOINTS.GET_MARKET_ITEMS,
  });

  // console.log('market: ', response);

  return response;
};

export const buyMarketItem = async (itemData: {
  currency: string;
  type: string;
  level?: number;
}) => {
  const response = await httpClientAuthorized.post<AppUser>(ENDPOINTS.BUY_ITEM, itemData);

  return response;
};

export const createInvoice = async (itemData: { item_id: string; currency: string }) => {
  const response = await httpClientAuthorized.post<any>(ENDPOINTS.CREATE_INVOICE, itemData);

  return response;
};

export const getPaymentStatus = async (paymentId: string) => {
  const response = await httpClientAuthorized.get(ENDPOINTS.GET_INVOICE_STATUS(paymentId));
  return response;
};

export const getRates = async () => {
  const response = await httpClientAuthorized.get(ENDPOINTS.GET_RATES);
  return response;
};
